import Button from "components/Button/Button";
import React from "react";
import ModalContent from "./ModalContent";

const DeleteFileModal = ({ open, onClose, type, handleRemove }) => {
  const typeName = type === "cv" ? "CV" : "File";

  return (
    <ModalContent
      open={open}
      onClose={onClose}
      variant="danger"
      className={"flex gap-4 p-8 rounded-lg"}
    >
      <div className="flex flex-col w-full">
        <span className="font-medium text-wce-neutral-10 mb-2">
          Delete {typeName}?
        </span>
        <span className="text-sm text-wce-neutral-10 mb-6">
          You can upload a new {typeName} afterwards.
        </span>
        <div className="self-end">
          <Button
            size="medium"
            color="danger"
            variant="secondary"
            className="mr-2"
            onClick={() => {
              handleRemove();
              onClose();
            }}
          >
            Delete
          </Button>
          <Button size="medium" color="danger" onClick={onClose}>
            Cancel
          </Button>
        </div>
      </div>
    </ModalContent>
  );
};

export default DeleteFileModal;
